/*
  sk-page-loader.js — the SIAMKICK "S" over the page while the next page
  loads. It only appears when a navigation is still pending after DELAY ms,
  so fast page loads never see it and nothing waits on it. Styles live in
  layout/theme.liquid (.sk-loader). Uses the Navigation API; browsers
  without it simply don't show the loader.
*/
(function () {
  if (!window.navigation || window.__skLoader) return;
  window.__skLoader = true;

  var DELAY = 350;
  var GIVE_UP = 10000;

  var S_PATH =
    'M0,-1411.51L-261.361,-1150.15L-261.361,-765.949L509.899,-765.949L376.243,-632.287L-261.361,-632.287L-522.182,-371.467L-522.182,0L-150.715,-371.467L502.946,-371.467L764.406,-632.926L764.406,-1014.98L-4.54,-1014.98L129.122,-1148.64L764.406,-1148.64L764.406,-1411.51L0,-1411.51Z';
  var svg = function (cls) {
    return (
      '<svg class="' + cls + '" viewBox="-523 -1412 1288 1413" aria-hidden="true" focusable="false">' +
      '<path d="' + S_PATH + '"/></svg>'
    );
  };

  var el = document.createElement('div');
  el.className = 'sk-loader';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-label', 'Loading');
  el.innerHTML =
    '<div class="sk-loader__mark">' + svg('sk-loader__ghost') + svg('sk-loader__fill') + '</div>';

  var showTimer, giveUpTimer;

  function hide() {
    clearTimeout(showTimer);
    clearTimeout(giveUpTimer);
    el.classList.remove('is-visible');
  }

  function show() {
    if (!el.isConnected) document.body.appendChild(el);
    // Force a style flush so the fade-in runs on first insert.
    void el.offsetWidth;
    el.classList.add('is-visible');
    giveUpTimer = setTimeout(hide, GIVE_UP);
  }

  navigation.addEventListener('navigate', function (event) {
    if (event.hashChange || event.downloadRequest !== null) return;
    if (event.destination.sameDocument) return;
    // The sign-up pop-up shows its own loading S on its button.
    if (document.querySelector('.sk-signup__primary.is-loading')) return;
    hide();
    showTimer = setTimeout(function () {
      if (!event.defaultPrevented) show();
    }, DELAY);
  });

  navigation.addEventListener('navigateerror', hide);

  // Back/forward cache restores this page as it was left — loader included.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) hide();
  });
})();
